import VPopup from './Popup';

export { VPopup };

export default VPopup;